export const AppId = {
    APPLICATION: {
        CHECK_IN_OUT: "CHECK_IN_OUT",
        ABSENCE: "ABSENCE",
        RESIGN: "RESIGN",
        SHIFT_SWAP: "SHIFT_SWAP",
        MISSION: "MISSION",
        OVERTIME: "OVERTIME",
        SHIFT_MORE: "SHIFT_MORE",
        FLEXIBLE: "FLEXIBLE",
        LEAVE: "LEAVE",
        SHIFT_REGISTRATION: "SHIFT_REGISTRATION",
        LATE_EARLY: "LATE_EARLY"
    },
    PERSONNEL: {
        RECORD: "RECORD",
        LABEL_CONTRACT: "LABEL_CONTRACT",
        DECISION: "DECISION"
    },
    WORK: {
        NORMAL: "NORMAL",
        PROJECT: "PROJECT",
        PROCESS: "PROCESS",
        PHASE: "PHASE",
        SEQUENCE: "SEQUENCE"
    },
    DECISION: {
        ADMISSION: "ADMISSION",
        APPOINTMENT: "APPOINTMENT",
        DISCIPLINE: "DISCIPLINE",
        DISMISSAL: "DISMISSAL",
        REWARD: "REWARD",
        SALARY: "SALARY",
        TRANSFER: "TRANSFER",
        CONTRACT: "DECISION_CONTRACT"
    },
    CMS: {
        ARTICLE: "ARTICLE"
    },
    PROCESS: {
        WORKFLOW: "WORKFLOW"
    },
    OFFICIAL_DISPATCH: {
        INCOMING: "INCOMING",
        OUTGOING: "OUTGOING",
    },
    OKR: {
        CHECKIN: "CHECKIN"
    },
    ASSET:{
        ASSET : "ASSET",
        ASSET_HANOVER: "ASSET_HANOVER"
    },
    SALARY : {
        SALARY_TABLE : "SALARY_TABLE"
    }
}
